/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 20.03.15.
 */

angular.module('cfn').constant('bookingIsoXmlConfig', {
  /**
   * See CFNPOC-6181.
   * The right required rights would be Company:UPDATE and Company:PRELIMINARY_BOOKING,
   * since the IsoXml Wizard can also import companies. But Company:UPDATE would require
   * the highest role ('Vollzugriff') which has all rights.
   *
   *
   * But the main use case for the wizard is importing of preliminary booking and should
   * be able if the user does not have the highest roles. We just require the roles
   * 'Verwalten (Stammdaten)' and 'Vorläufig Dokumentieren'.
   *
   * Thus we'll live with the risk that a user without rights can import a company.
   */
  requiredRights:
    'Company:PRELIMINARY_BOOKING,' +
    'Person:CREATE,Person:UPDATE,' +
    'Machine:CREATE,Machine:UPDATE,' +
    'Field:CREATE,Field:UPDATE'
});
